import React from "react";
import { styled } from "@mui/system";

const Wrapper = styled("div")(({ layout }) => ({
  display: "flex",
  flexDirection: layout === "column" ? "column" : "row",
  justifyContent: layout === "row" ? "space-between" : "flex-start",
  alignItems: layout === "row" ? "flex-start" : "flex-start",
  flexWrap: "wrap",
  margin: "12px 0",
  width: "100%",
}));

const Title = styled("span")(({ fontSize }) => ({
  fontFamily: "Arial, sans-serif",
  fontWeight: "bold",
  fontSize: fontSize || "14px",
  color: "#333",
  marginBottom: "4px",
  marginRight: "8px",
  minWidth: "fit-content",
}));

const Value = styled("span")(({ fontSize }) => ({
  fontFamily: "Courier New, monospace",
  fontSize: fontSize || "16px",
  color: "#555",
  wordWrap: "break-word",
  minWidth: 0,
}));

const Detail = ({ title, value, fontSize, layout = "column" }) => (
  <Wrapper layout={layout}>
    <Title fontSize={fontSize}>{title}{layout === "row" ? ":" : ""}</Title>
    <Value fontSize={fontSize}>{value}</Value>
  </Wrapper>
);

export default Detail;
